module.exports = __webpack_public_path__ + "static/media/payment_selected.9695879a.svg";